import * as React from "react";
import {Redirect} from 'react-router-dom';
import guest from '../../routes/guest';


export default (): JSX.Element =>
  <Redirect to={guest.login.path} />